export const CHECKOUT_URL = 'https://protocollo.impultienda.ar/checkout/'

export const PRICE = '19 €'

export const HERO_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/bDv66WcTMqAzWYGG4cLHkr/CLINICA-IT.png'

export const KARITO_PHOTO =
  'https://cdn.magicpatterns.com/patterns/generated-images/455a9c5a-2dc7-490e-b3f3-9a3152b39f4a.jpg'

export const heroStats: { value: string; label: string }[] = [
  { value: '+300', label: 'Protocolli e strumenti clinici' },
  { value: '+1.200', label: 'Odontoiatri che lo utilizzano' },
  { value: '+2.400', label: 'Ore di incertezza ridotte' },
  { value: '97%', label: 'Si sente più sicuro nel pianificare' },
]

export const beforeItems: string[] = [
  'Dubitavi prima di accettare un caso complesso',
  'Definivi la DVO per intuizione',
  'Improvvisavi in base al paziente',
  'Temevi i rifacimenti',
  'Inviavi ad altri i trattamenti complessi',
  'Ogni caso era diverso dal precedente',
]

export const afterItems: string[] = [
  'Valuti ogni caso con un protocollo chiaro',
  'Prendi decisioni con criteri oggettivi',
  'Segui un processo passo dopo passo',
  'Pianifichi con maggiore prevedibilità',
  'Aumenti la fiducia per accettarli',
  'Tutti seguono lo stesso metodo clinico',
]

export const painPoints: { emoji: string; text: string }[] = [
  {
    emoji: '😰',
    text: 'Hai un paziente con usura severa e non sai esattamente da dove iniziare.',
  },
  {
    emoji: '⏱️',
    text: 'Investi troppo tempo a rivedere appunti prima di pianificare una riabilitazione.',
  },
  {
    emoji: '🤷',
    text: 'Hai ancora dubbi quando devi decidere se modificare la DVO.',
  },
  {
    emoji: '💸',
    text: 'Sai che potresti accettare trattamenti di maggior valore, ma l’insicurezza ti frena.',
  },
  {
    emoji: '😓',
    text: 'Hai avuto rifacimenti che si sarebbero potuti evitare con una pianificazione migliore.',
  },
  {
    emoji: '😩',
    text: 'Prima di iniziare un caso complesso, senti più incertezza che fiducia.',
  },
]

export const volumes: {
  number: string
  title: string
  description: string
}[] = [
  {
    number: 'Tomo I',
    title: 'Diagnostica con sicurezza prima di toccare un dente',
    description:
      'Impara a valutare qualsiasi caso complesso con un protocollo che ti aiuta a identificare i rischi, prendere decisioni migliori e sapere esattamente quando accettare un trattamento.',
  },
  {
    number: 'Tomo II',
    title: 'Non dubitare mai più nel definire la dimensione verticale',
    description:
      'Scopri un metodo passo dopo passo per determinare quando modificare la DVO e pianificare riabilitazioni con maggiore sicurezza e prevedibilità.',
  },
  {
    number: 'Tomo III',
    title: 'Progetta riabilitazioni belle da vedere… e che durino anni',
    description:
      'Integra estetica e funzione con un sistema che ti aiuterà a ridurre le fratture, migliorare la stabilità e aumentare la soddisfazione del paziente.',
  },
  {
    number: 'Tomo IV',
    title: 'L’ordine corretto per riabilitare senza rifacimenti',
    description:
      'Conosci la sequenza clinica che ti permetterà di organizzare trattamenti complessi, ridurre gli errori e limitare gli aggiustamenti inutili.',
  },
  {
    number: 'Tomo V',
    title: 'Come risolvere le complicanze prima che diventino un problema',
    description:
      'Impara protocolli chiari per prevenire e gestire fratture, sensibilità, fastidi occlusali e altre complicanze frequenti.',
  },
  {
    number: 'Tomo VI',
    title: 'Trasforma una buona diagnosi in trattamenti ad alto valore',
    description:
      'Scopri come presentare casi complessi con autorevolezza, perché i tuoi pazienti comprendano il valore del trattamento e accettino con più fiducia.',
  },
]

export const instantAccess: { icon: string; text: string }[] = [
  {
    icon: '📝',
    text: 'Oltre 30 protocolli clinici pronti da applicare in ogni fase del trattamento.',
  },
  {
    icon: '📋',
    text: 'Checklist professionali per ridurre gli errori e standardizzare il tuo processo di lavoro.',
  },
  {
    icon: '🦷',
    text: 'Algoritmi di decisione clinica che eliminano l’improvvisazione davanti ai casi complessi.',
  },
  {
    icon: '📊',
    text: 'Matrici di valutazione e filtri di rischio per analizzare ogni caso prima del preventivo.',
  },
  {
    icon: '📸',
    text: 'Guide visive e strumenti di pianificazione per documentare ed eseguire con prevedibilità.',
  },
]

export const bonuses: {
  tag: string
  value: string
  title: string
  description: string
  image: string
}[] = [
  {
    tag: 'Bonus #1',
    value: 'Valore 47 €',
    title: '50 Casi Clinici Risolti',
    description:
      'Impara come una riabilitatrice esperta analizza, pianifica e risolve i casi più complessi, prima di affrontarli nel tuo studio.',
    image:
      'https://cdn.magicpatterns.com/uploads/j1tsmS7jjdZVMAGSTJPesX/BONUS_1_CLINICA-IT.png',
  },
  {
    tag: 'Bonus #2',
    value: 'Valore 37 €',
    title: 'Protocollo Diagnosi in 10 Minuti™',
    description:
      'Un algoritmo pratico per valutare rapidamente qualsiasi caso, individuare i rischi e decidere con maggiore sicurezza fin dalla prima visita.',
    image:
      'https://cdn.magicpatterns.com/uploads/h1Bkc8T4kj8rdUSRH7FJkq/BONUS_2_CLINICA-IT.png',
  },
  {
    tag: 'Bonus #3',
    value: 'Valore 47 €',
    title: 'Clinical Mistakes Library™',
    description:
      'Scopri gli errori che provocano fratture, rifacimenti e complicanze, per evitarli prima di iniziare qualsiasi riabilitazione.',
    image:
      'https://cdn.magicpatterns.com/uploads/4Ea6zucBe6S7Tfmbd19m75/BONUS_3_CLINICA-IT.png',
  },
  {
    tag: 'Bonus #4',
    value: 'Valore 37 €',
    title: 'High-Value Case Scripts',
    description:
      'Script pronti per presentare i preventivi, rispondere alle obiezioni e trasmettere il valore dei tuoi trattamenti con più sicurezza.',
    image:
      'https://cdn.magicpatterns.com/uploads/crfQQKPaZULV7d1EyppjS7/BONUS_4_CLIN_ICA-IT.png',
  },
  {
    tag: 'Bonus #5',
    value: 'Valore 29 €',
    title: 'Pack di 30 Checklist Cliniche',
    description:
      'Una raccolta di checklist per ogni fase del trattamento, per lavorare con ordine, ridurre gli errori e guadagnare prevedibilità.',
    image:
      'https://cdn.magicpatterns.com/uploads/9AM5T2vn6F9QrEtm3DHBpH/BONUS_5_CLINICA-IT.png',
  },
]

export const testimonials: {
  quote: string
  name: string
  country: string
  flag: string
  photo: string
}[] = [
  {
    quote:
      'Per anni ho provato insicurezza nel pianificare riabilitazioni complete. Oggi ho un protocollo che mi guida dalla diagnosi all’esecuzione.',
    name: 'Giulia R.',
    country: 'Italia',
    flag: '🇮🇹',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/220507ba-d2c7-4718-8be9-47470c9e2fa3.jpg',
  },
  {
    quote:
      'Il sistema di semaforo clinico ha cambiato completamente il mio modo di valutare i pazienti. Ora decido con molta più tranquillità.',
    name: 'Marco F.',
    country: 'Italia',
    flag: '🇮🇹',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/95f15c3e-d3b4-427a-ba46-f758b9cd0a79.jpg',
  },
  {
    quote:
      'Il Tomo VI mi ha aiutato a spiegare meglio i miei trattamenti. I pazienti capiscono il valore della diagnosi e accettano molto più facilmente.',
    name: 'Sara M.',
    country: 'Italia',
    flag: '🇮🇹',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/b099d6f3-6477-40ce-aed5-fd32acd9e963.jpg',
  },
  {
    quote:
      'Le checklist sono diventate parte della mia routine quotidiana. Mi aiutano a non tralasciare dettagli importanti in nessun caso.',
    name: 'Alessandro C.',
    country: 'Svizzera',
    flag: '🇨🇭',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/446ac3f3-bc53-489b-b61d-0afca5842b35.jpg',
  },
  {
    quote:
      'Non ho comprato dei PDF. Ho comprato un sistema che mi aiuta a lavorare con più sicurezza tutti i giorni.',
    name: 'Chiara B.',
    country: 'Italia',
    flag: '🇮🇹',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/78dc14e4-8eb3-456d-8405-9b81f2133f92.jpg',
  },
]

export const faqs: { question: string; answer: string }[] = [
  {
    question: 'Come riceverò il materiale?',
    answer:
      'Subito dopo il pagamento riceverai un’email con l’accesso per scaricare tutti i tomi e i bonus in formato PDF.',
  },
  {
    question: 'Il contenuto è valido per qualsiasi paese?',
    answer:
      'Sì. I protocolli, gli algoritmi e le checklist sono criteri clinici applicabili indipendentemente dal paese in cui eserciti.',
  },
  {
    question: 'Devo essere uno specialista?',
    answer:
      'No. È pensato per odontoiatri che lavorano — o vogliono lavorare — con casi di riabilitazione orale più complessi.',
  },
  {
    question: 'I file sono scaricabili?',
    answer:
      'Sì. Tutto il materiale è in PDF scaricabile e consultabile da computer, tablet e smartphone.',
  },
  {
    question: 'È un pagamento unico?',
    answer:
      'Sì. Un solo pagamento, nessun abbonamento e accesso a vita al materiale acquistato.',
  },
  {
    question: 'Cosa succede se non è ciò che mi aspettavo?',
    answer:
      'Hai 7 giorni di garanzia. Ti basta scriverci un’email e ti rimborsiamo il 100% del tuo denaro.',
  },
]

export const buyers: { name: string; country: string; flag: string }[] = [
  { name: 'Sofia T.', country: 'Ecuador', flag: '🇪🇨' },
  { name: 'Dott. Luca M.', country: 'Italia', flag: '🇮🇹' },
  { name: 'Dra. Camila R.', country: 'Argentina', flag: '🇦🇷' },
  { name: 'Dr. Andrés P.', country: 'Colombia', flag: '🇨🇴' },
  { name: 'Dra. Valentina S.', country: 'Cile', flag: '🇨🇱' },
  { name: 'Dr. Javier L.', country: 'Spagna', flag: '🇪🇸' },
  { name: 'Dra. Fernanda G.', country: 'Messico', flag: '🇲🇽' },
  { name: 'Dott.ssa Elena B.', country: 'Italia', flag: '🇮🇹' },
  { name: 'Dr. Sebastián T.', country: 'Perù', flag: '🇵🇪' },
  { name: 'Dra. Mariana C.', country: 'Uruguay', flag: '🇺🇾' },
  { name: 'Dra. Paula N.', country: 'Costa Rica', flag: '🇨🇷' },
  { name: 'Dr. Gonzalo A.', country: 'Paraguay', flag: '🇵🇾' },
]
